<img *ngIf="showParentBanner" style="width: 100%" src="assets/parent-portal-banner.png">
<nav class="navbar navbar-expand-md navbar-light no-print px-3 px-md-5">
  <a class="navbar-brand" routerLink="{{getHomeUrl()}}" style="margin-right: 40px">
    <img src="assets/logo.png" style="width: 120px">
  </a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"
    (click)="collapsed=!collapsed">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarSupportedContent" [class.collapse]="collapsed">
    <ul class="navbar-nav mr-auto">
      <li *ngFor="let navItem of navItems" class="nav-item">
        <a class="nav-link" routerLink="{{ navItem.routerLink }}"> {{ navItem.title }}
          <span class="sr-only">(current)</span>
        </a>
      </li>
    </ul>
    <div class="d-flex align-items-center" *ngIf="authService.isLoggedIn()">
      <div class="mr-3">
        <app-teacher-menu-link></app-teacher-menu-link>
      </div>
      <span>{{ authService.session.Name }}</span>
      <div ngbDropdown placement="bottom-right">
        <app-profile-picture *ngIf="authService?.session?.Name" class="ml-2 pointer" [name]="authService.session.Name"
          ngbDropdownToggle></app-profile-picture>
        <div ngbDropdownMenu class="dropdown-menu-right">
          <a class="dropdown-item" routerLink="{{getAccountUrl()}}">My account</a>
          <a *ngIf="!isParent" class="dropdown-item" href="https://joyschoolenglish.com/start" target="_blank">Teacher resources</a>
          <a *ngIf="!isParent" class="dropdown-item" [href]="environment.PLAY_URL" target="_blank">Joy School English login</a>
          <div class="dropdown-item pointer" (click)="logout()">Log out</div>
        </div>
      </div>
    </div>
  </div>
</nav>
<img src="assets/header_bottom.png" style="height: 4px; width: 100%" class="no-print">
<div id="print-header" class="print-only">
  <img src="assets/logo.png" style="width: 10%;">
</div>